import type { ComponentType } from 'react';
import { AiOutlineHome } from 'react-icons/ai';
import { BsFileEarmark, BsHeadset, BsJournals, BsReceipt, BsTruck } from 'react-icons/bs';
import { CgFileDocument } from 'react-icons/cg';
import { FaBarcode } from 'react-icons/fa';
import { IconType } from 'react-icons';

import FacebookIcon from 'assets/icons/facebook-round.svg';
import InstagramIcon from 'assets/icons/instagram-round.svg';
import LinkedinIcon from 'assets/icons/linkedin-round.svg';
import YoutubeIcon from 'assets/icons/youtube-round.svg';
import { BiWrench } from 'react-icons/bi';

type Page = {
  name: string;
  slug: string[];
  icon?: IconType | ComponentType<{ className?: string }>;
  url?: string;
  ariaLabel?: string;
  showLink?: boolean;
  param?: string;
  type?: string;
  action?: 'chat';
  subMenu?: Page[];
};

export const pages: Page[] = [
  {
    name: 'Início',
    slug: ['inicio'],
    icon: AiOutlineHome,
    url: 'portal',
    ariaLabel: 'Página inicial',
    showLink: true,
  },
  {
    name: 'Boletos',
    slug: ['boletos'],
    icon: FaBarcode,
    url: 'boletos',
    ariaLabel: 'Página de boletos',
    showLink: true,
  },
  {
    name: 'Notas',
    slug: ['notas'],
    icon: BsReceipt,
    url: 'notas',
    ariaLabel: 'Página de notas',
    showLink: true,
  },
  {
    name: 'Abastecimento',
    slug: ['abastecimento', 'pedido-abastecimento', 'tracking'],
    icon: BsTruck,
    url: 'abastecimento',
    ariaLabel: 'Página abastecimento',
    showLink: true,
    subMenu: [
      {
        name: 'Novo pedido',
        slug: ['pedido-abastecimento'],
        url: 'pedido-abastecimento',
        ariaLabel: 'Página novo pedido',
        showLink: true,
      },
      {
        name: 'Histórico de solicitações',
        slug: ['tracking'],
        url: 'tracking',
        ariaLabel: 'Página histórico de solicitações',
        showLink: true,
      },
      {
        name: 'Melhores horários',
        slug: ['melhores-horarios'],
        url: 'melhores-horarios',
        ariaLabel: 'Página melhores horários',
        showLink: true,
      },
    ],
  },
  {
    name: 'Manutenção',
    slug: ['main-manutencao', 'manutencao', 'documentacao-os'],
    icon: BiWrench,
    url: 'main-manutencao',
    ariaLabel: 'Página manutenção',
    showLink: true,
    subMenu: [
      {
        name: 'Solicitar manutenção',
        slug: ['manutencao'],
        url: 'manutencao',
        ariaLabel: 'Página Manutenção',
        showLink: true,
      },
      {
        name: 'Histórico de ordens de serviço',
        slug: ['documentacao-os'],
        url: 'documentacao-os',
        ariaLabel: 'Histórico de ordens de serviço',
        showLink: true,
      },
    ],
  },
  {
    name: 'Documentos técnicos',
    slug: ['documentacao'],
    icon: BsJournals,
    // BsJournals
    url: 'documentacao',
    ariaLabel: 'Pasta técnica',
    showLink: true,
  },
  {
    name: 'Meus contratos',
    slug: ['meus-contratos'],
    icon: BsFileEarmark,
    url: 'meus-contratos',
    ariaLabel: 'Meus contratos',
    showLink: true,
  },
  {
    name: 'Adicionar empresa',
    slug: ['nova-empresa'],
    icon: CgFileDocument,
    url: 'nova-empresa',
    ariaLabel: 'Página novo contrato',
    showLink: true,
  },
  {
    name: 'Fale conosco',
    slug: ['contato', 'duvidas-frequentes', 'dicas-seguranca', 'atendimento-comercial'],
    icon: BsHeadset,
    url: 'contato',
    ariaLabel: 'Página fale conosco',
    showLink: true,
    subMenu: [
      {
        name: 'Dúvidas frequentes',
        slug: ['duvidas-frequentes'],
        url: 'fale-conosco',
        ariaLabel: 'Página dúvidas frequentes',
        showLink: true,
        param: 'faq',
      },
      {
        name: 'Falar via chat',
        slug: ['chat'],
        ariaLabel: 'Falar via chat',
        showLink: true,
        action: 'chat',
      },
      {
        name: 'Dicas de segurança',
        slug: ['dicas-seguranca'],
        url: 'dicas-seguranca',
        ariaLabel: 'Página dicas de segurança',
        showLink: true,
      },
      {
        name: 'Atendimento comercial',
        slug: ['atendimento-comercial'],
        url: 'atendimento-comercial',
        ariaLabel: 'Página atendimento comercial',
        showLink: true,
      },
    ],
  },
];

export const socials = [
  {
    img: FacebookIcon,
    alt: 'Facebook',
    href: 'https://www.facebook.com/ultragazoficial/',
  },
  {
    img: YoutubeIcon,
    alt: 'Youtube',
    href: 'https://www.youtube.com/user/UltragazBrasilgas',
  },
  {
    img: InstagramIcon,
    alt: 'Instagram',
    href: 'https://www.instagram.com/ultragazoficial/',
  },
  {
    img: LinkedinIcon,
    alt: 'Linkedin',
    href: 'https://www.linkedin.com/company/ultragaz/mycompany/',
  },
];
